export default "__VITE_ASSET__a337d2bc__"